// 分账接口
import request from '@/utils/request'

// 分账账号列表
export function ProfitSharingReceiversList(data){
    return request({
      url: '/profitsharing/receivers/list',
      method: 'post',
      data: data
    })
}

//分账订单列表

export function ProfitSharingOrderList(data){
  return request({
    url: '/profitsharing/order/list',
    method: 'post',
    data: data
  })
}